/* eslint eqeqeq: "off" */
import React, { useEffect, useRef, useState } from "react";
import MetaTags from "react-meta-tags";
import { Col, Row, Modal, Tooltip, Badge, Skeleton, Popover, Spin } from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  ArrowLeftOutlined,
  ExclamationCircleOutlined,
  DownloadOutlined,
  DownOutlined,
  ShareAltOutlined,
  PrinterFilled,
} from "@ant-design/icons";
import "./index.css";
import { useHistory } from "react-router";
import moment from "moment";
import PropTypes from "prop-types";
import { isEmpty } from "lodash";
import { useDispatch } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import {
  deleteSalesInvoiceList,
  loadSalesInvoice,
  // loadTotalPaid,
  // loadTotalUnPaid,
} from "../../store/sales-invoice/actions";
import { ledgerStatementList } from "./data";
import html2canvas from "html2canvas";
// import { BsCashCoin } from "react-icons/bs";
import { ToWords } from "to-words";
import jsPDF from "jspdf";
import ReactToPrint from "react-to-print-advanced";
import useMedia from "use-media-antd-query";

const SalesInvoiceSelection = (props) => {
  const [loading, setLoading] = useState(false);
  const [salesPrint, setSalesPrint] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const dispatch = useDispatch();
  const media = useMedia();

  //organisation id from login response
  const userName = localStorage.getItem("authData");

  const userNameDetails = JSON.parse(userName);

  const userInfoDetails = !isEmpty(userNameDetails)
    ? userNameDetails.user.organizations[0].organizationId
    : "";
  const userOrganisationName = !isEmpty(userNameDetails)
    ? userNameDetails.user.organizations[0].organizationName
    : "";
  // const userInfoMobile = !isEmpty(userNameDetails)
  //   ? userNameDetails.user.mobileNo
  //   : "";
  const purchaseListId = { organizationId: userInfoDetails };

  //partys tabs

  //Props values from parties home

  const itemList =
    props.location && props.location.state ? props.location.state.itemLi : "";

  const userId = props.location.state ? props.location.state.userId : "";

  const salesInvoiceData =
    props.location && props.location.state
      ? props.location.state.salesInvoice
      : "";
  // const paidAmount =
  //   props.location && props.location.state ? props.location.state.paid : "";
  // const unPaidAmount =
  //   props.location && props.location.state ? props.location.state.unpaid : "";
  const billStatus =
    salesInvoiceData &&
    salesInvoiceData.billStatus &&
    salesInvoiceData.billStatus.length > 0
      ? salesInvoiceData.billStatus[0].billStatusNo
      : "";
  const billStatusName =
    salesInvoiceData &&
    salesInvoiceData.billStatus &&
    salesInvoiceData.billStatus.length > 0
      ? salesInvoiceData.billStatus[0].statusName
      : "";
  const partyAddress =
    salesInvoiceData &&
    salesInvoiceData.partyAddress &&
    salesInvoiceData.partyAddress.length > 0
      ? salesInvoiceData.partyAddress[0]
      : "";

  //api loader
  useEffect(() => {
    dispatch(loadSalesInvoice(purchaseListId));
    // dispatch(loadTotalPaid(purchaseListId));
    // dispatch(loadTotalUnPaid(purchaseListId));
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //Reducer state
  // const { total_paid_list = [], total_unpaid_list = [] } = useSelector(
  //   (state) => state.SalesInvoice
  // );

  const [pageRouting, setPageRouting] = useState(false);
  const history = useHistory();

  //category api integrations
  const [deletePurchaseModal, setDeletePurchaseModal] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  //deletPurchase api integrations
  const deletePurchaseInvoiceDetails = () => {
    setIsButtonDisabled(true);
    setTimeout(() => {
      setIsButtonDisabled(false);
    }, 4000);
    const itemListData = {
      organizationId: userInfoDetails,
      siId: [salesInvoiceData._id],
      deletedBy: !isEmpty(userNameDetails) ? userNameDetails.user._id : "",
    };
    dispatch(deleteSalesInvoiceList(itemListData));
    setTimeout(() => {
      dispatch(loadSalesInvoice(purchaseListId));
      setDeletePurchaseModal(false);
      setTimeout(() => {
        history.push("/sales-invoice");
      }, 1000);
      toast.error("Sales invoice deleted successfully");
    }, 1000);
  };

  //Ledger statement section

  // const [mouseEnter, setMouseEnter] = useState(false);
  const [ledgerData, setLedgerData] = useState({
    startMonth: "",
    endMonth: "",
    startOfMonth: "",
    endOfMonth: "",
  });
  // const [isDevToolsOpen, setIsDevToolsOpen] = useState(false);
  const startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
  const endOfMonth = moment().endOf("month").format("YYYY-MM-DD");

  console.log(ledgerData, "ledgerData");
  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
    setLedgerData({
      startMonth: "",
      endMonth: "",
      startOfMonth: startOfMonth,
      endOfMonth: endOfMonth,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toWords = new ToWords();

  // const [downloadLoading, setDownloadLoading] = useState(false);
  const salesInvoiceRef = useRef();
  // const contentRef = useRef();
  const handleDownloadPDF = () => {
    // const input = document.getElementById("pdf-content");

    setDownloadLoading(true);
    setTimeout(() => {
      setDownloadLoading(false);
    }, 3000);
    const content = salesInvoiceRef.current;

    setTimeout(() => {
      html2canvas(content).then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "mm", "a4");
        const imgWidth = 195;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        pdf.addImage(imgData, "PNG", 8, 10, imgWidth, imgHeight);
        pdf.save("Sales-invoice.pdf");
      });
    }, 1200);
  };

  //Calculate totals
  const calculateTotals = (rows) => {
    let quantityCount = 0;

    rows.forEach((row) => {
      quantityCount += parseFloat(row.qty) || 0;
    });

    return { quantityCount };
  };

  const [totals, setTotals] = React.useState({
    quantityCount: 0,
  });

  useEffect(() => {
    if (salesInvoiceData && salesInvoiceData.items.length > 0) {
      const total = calculateTotals(salesInvoiceData.items);
      setTotals(total);
    }
  }, [salesInvoiceData]);

  //window height/width
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  //sales invoice items

  const itemsDetailsArray =
    salesInvoiceData.items && salesInvoiceData.items.length > 0
      ? salesInvoiceData.items.flatMap((item) =>
          item.serialDetails.map((serial) => ({
            itemId: item.itemId,
            modelName: item.modelName,
            brandName: item.brandName,
            brandId: item.brandId,
            qty: Number(item.qty / item.serialDetails.length), // Adjusted for each split item
            serialDetails: serial,
            _id: item._id,
          }))
        )
      : [];

  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Sales Invoice | Mbook</title>
        </MetaTags>
      </div>

      <Row className="border-solid rounded-sm">
        <Col span={24}>
          <Row>
            <Col span={24}>
              <Row>
                <Col
                  span={24}
                  className="bg-[#ffffff] border border-b-1 border-x-0 border-t-0 pb-2"
                >
                  <div className="font-poppins flex justify-between pl-[20px] pr-[20px] mt-2">
                    <div className="flex">
                      <ArrowLeftOutlined
                        onClick={() => setPageRouting(true)}
                        className="font-bold text-[18px]"
                      />
                      <h1
                        style={{
                          fontFamily: "Poppins",
                        }}
                        className="text-[18px] ml-2 mt-1 font-semibold"
                      >
                        {"Sales Invoice #"}
                        {salesInvoiceData ? salesInvoiceData.salesinvoiceNo : 1}
                      </h1>
                      <Badge
                        className={
                          billStatus === 1
                            ? "bg-[#edf6ef] font-semibold rounded-md text-[#49a563] h-[30px] mt-1 p-2 ml-4"
                            : billStatus === 3
                            ? "bg-[#ebc951e0] font-semibold rounded-md text-[white] h-[30px] mt-1 p-2 ml-4"
                            : "bg-[#f1e7e9] font-semibold rounded-md text-[#d01717] h-[30px] mt-1 p-2 ml-4"
                        }
                      >
                        {billStatusName}
                      </Badge>
                    </div>

                    <div className="flex">
                      <Tooltip
                        title="Edit Sales Invoice"
                        placement="left"
                        rootClassName="text-[10px]"
                      >
                        <div
                          onClick={() => {
                            history.push({
                              pathname: "/create-sales-invoice",
                              state: {
                                salesInvoiceData: salesInvoiceData
                                  ? salesInvoiceData
                                  : "",
                                organizationId: userInfoDetails,
                                userId: userId,
                                itemList: itemList,
                              },
                            });
                          }}
                          className="border flex rounded-md justify-between  pl-3 pr-1 pt-1 pb-1 ml-3  cursor-pointer"
                        >
                          <EditOutlined className="text-[18px] pr-3" />
                        </div>
                      </Tooltip>
                      <Tooltip
                        title="Delete This Sales Return"
                        placement="bottom"
                        rootClassName="text-[10px]"
                      >
                        <div
                          onClick={() => setDeletePurchaseModal(true)}
                          className="border border-1 border-red-200 text-[red] rounded-md ml-3 pl-3 pr-3 pt-1 pb-1 cursor-pointer"
                        >
                          <DeleteOutlined />
                        </div>
                      </Tooltip>
                    </div>
                  </div>
                </Col>
                <Col span={24} className="pl-4 pt-4 pb-4 pr-1 bg-[#ffffff]">
                  <Row>
                    <Col span={20}>
                      <Row>
                        <Col md={7} lg={6} sm={12} xs={24} className="pr-3">
                          {loading ? (
                            <Skeleton.Input className="w-[100%]"></Skeleton.Input>
                          ) : (
                            <div
                              style={{
                                fontFamily: "Poppins",
                              }}
                              onClick={handleDownloadPDF}
                              className="cursor-pointer flex border pt-2 pb-2 pl-12 pr-8 rounded-md border-1 track-wider text-center"
                            >
                              {downloadLoading ? (
                                <p className="flex">
                                  <Spin className="mr-2" /> Downloading
                                </p>
                              ) : (
                                <div className="flex">
                                  <DownloadOutlined className="text-[16px] mr-3" />{" "}
                                  Download
                                </div>
                              )}
                            </div>
                          )}
                        </Col>
                        <Col md={7} lg={6} sm={12} xs={24} className="pr-3">
                          {loading ? (
                            <Skeleton.Input className="w-[100%]"></Skeleton.Input>
                          ) : (
                            <div
                              className="cursor-pointer w-[100%]"
                              onClick={() => {
                                setSalesPrint(true);
                                setTimeout(() => {
                                  setSalesPrint(false);
                                }, 4000);
                              }}
                            >
                              <ReactToPrint
                                trigger={() => (
                                  <div
                                    style={{
                                      fontFamily: "Poppins",
                                    }}
                                    className=" track-wider flex border pt-2 pb-2 pl-12 pr-8 rounded-md  border-1 text-center"
                                  >
                                    {salesPrint ? (
                                      <p className="flex">
                                        <Spin className="mr-2" /> Loading
                                      </p>
                                    ) : (
                                      <div className="flex">
                                        <PrinterFilled className="cursor-pointer text-[16px] mr-3" />
                                        Print PDF
                                      </div>
                                    )}
                                  </div>
                                )}
                                delay={1500}
                                content={() => salesInvoiceRef.current}
                              />
                            </div>
                          )}
                        </Col>
                        <Col md={7} lg={6} sm={12} xs={24}>
                          {loading ? (
                            <Skeleton.Input className="w-[100%]"></Skeleton.Input>
                          ) : (
                            <div className="text-start">
                              <Popover
                                placement="bottomRight"
                                trigger={"click"}
                                content={ledgerStatementList}
                              >
                                <Tooltip
                                  title="Easily perform bulk actions on all your Parties"
                                  placement="left"
                                  rootClassName="text-[10px]"
                                >
                                  <div
                                    style={{
                                      fontFamily: "Poppins",
                                    }}
                                    className="border rounded-sm flex justify-between pl-3 pr-2 pt-2 pb-2 cursor-pointer"
                                  >
                                    <div>
                                      <ShareAltOutlined className="mr-2" />
                                      Share
                                    </div>
                                    <DownOutlined />
                                  </div>
                                </Tooltip>
                              </Popover>
                            </div>
                          )}
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>

                <Col
                  span={24}
                  className={
                    (windowDimensions.height >= 700 &&
                      windowDimensions.height <= 767) ||
                    (windowDimensions.height > 767 &&
                      windowDimensions.height < 830)
                      ? "add-vouchers-sales-main-large-device"
                      : windowDimensions.height > 830 &&
                        windowDimensions.height < 900
                      ? "add-vouchers-sales-main-extra-large-device"
                      : windowDimensions.height > 900 &&
                        windowDimensions.height < 1000
                      ? "add-vouchers-sales-main-extra-extra-large-device"
                      : windowDimensions.height > 1000
                      ? "add-vouchers-sales-main-extra-infinite-device"
                      : "add-vouchers-sales-main"
                  }
                >
                  <Row className="flex justify-center">
                    <Col
                      span={media === "xxl" ? 14 : 20}
                      className="mb-4 mt-3 pb-6"
                    >
                      <div
                        className={
                          "rounded-sm bg-[#ffffff] pb-3 pl-8 pr-8 mb-3"
                        }
                      >
                        <Row>
                          <Col span={24} className="pb-3 mt-5 ml-4">
                            <h1 className="text-[14px] font-semibold uppercase mt-2 party-label">
                              {salesInvoiceData
                                ? salesInvoiceData.transActionType
                                : ""}
                            </h1>
                          </Col>
                        </Row>
                        <Row
                          className={
                            salesPrint
                              ? "flex bg-[#ffffff] justify-center ml-5 mr-5 mt-4 mb-4"
                              : downloadLoading
                              ? "flex bg-[#ffffff] justify-center ml-[20px] mr-[50px] mt-2 mb-4"
                              : "flex bg-[#ffffff] justify-center ml-3 mr-4 mt-2 mb-4"
                          }
                          style={{
                            border: "1px solid black",
                          }}
                          // id="pdf-content"
                          ref={salesInvoiceRef}
                        >
                          <Col
                            md={24}
                            className={
                              "pt-4 pb-4 border-solid rounded-sm bg-[#ffffff]"
                            }
                          >
                            <Row>
                              <Col span={24} className="pb-3 pt-3 text-center">
                                <div
                                  style={{
                                    fontFamily: "Poppins",
                                  }}
                                  className="w-[100%]"
                                >
                                  <p className="party-label">
                                    <p className="text-[18px] text-center font-semibold capitalize">
                                      {userOrganisationName
                                        ? userOrganisationName
                                        : ""}
                                    </p>
                                  </p>
                                  <p className="party-label">
                                    <p className="text-[13px] text-center font-semibold mr-2">
                                      Mobile:
                                    </p>
                                    <p className="text-[13px]">
                                      {salesInvoiceData
                                        ? salesInvoiceData.partyMobileNo
                                        : ""}
                                    </p>
                                  </p>
                                </div>
                              </Col>
                              <Col
                                span={24}
                                style={{
                                  border: "1px solid black",
                                  borderLeft: "none",
                                  borderRight: "none",
                                  borderBottom: salesPrint
                                    ? "1px solid black"
                                    : "1px solid black",
                                }}
                              >
                                <Row>
                                  <Col
                                    md={11}
                                    sm={24}
                                    lg={11}
                                    xs={24}
                                    style={{
                                      borderRight: salesPrint
                                        ? ""
                                        : "1px solid black",
                                      borderBottom: salesPrint
                                        ? "1px solid black"
                                        : "",
                                    }}
                                  >
                                    <div className="p-2 pt-3 pb-3">
                                      <h1 className="purchase-label text-[12px] font-semibold mr-3 uppercase">
                                        Bill From:
                                      </h1>
                                      <p className="mt-1 text-[14px] purchase-label font-semibold">
                                        {salesInvoiceData
                                          ? salesInvoiceData.partyName
                                          : ""}
                                      </p>
                                      <p className="mt-1 text-[12px] purchase-label">
                                        Address:{" "}
                                        {partyAddress
                                          ? partyAddress.address1 +
                                            ", " +
                                            partyAddress.city +
                                            ", " +
                                            "Tamil Nadu" +
                                            // partyAddress.vendorStateName || "" +
                                            " - " +
                                            partyAddress.pincode
                                          : ""}
                                      </p>
                                    </div>
                                  </Col>
                                  <Col
                                    md={13}
                                    sm={24}
                                    lg={13}
                                    xs={24}
                                    style={{
                                      borderBottom: salesPrint
                                        ? "1px solid black"
                                        : "",
                                    }}
                                  >
                                    <Row className="w-[100%] flex justify-between pl-8 pr-5 pt-5 pb-5">
                                      <div className="w-[33%]">
                                        <h1 className="purchase-label text-[12px] font-semibold mr-3">
                                          Invoice No:
                                        </h1>
                                        <p className="mt-[1px] text-[13px] purchase-label">
                                          {salesInvoiceData
                                            ? salesInvoiceData.salesinvoiceNo
                                            : 1}
                                        </p>
                                      </div>
                                      <div className="w-[33%]">
                                        <h1 className="purchase-label text-[12px] font-semibold mr-3">
                                          Invoice Date:
                                        </h1>
                                        <p className="mt-[1px] text-[13px] purchase-label">
                                          {salesInvoiceData
                                            ? moment(
                                                salesInvoiceData.salesinvoiceDate
                                              ).format("DD/MM/YYYY")
                                            : ""}
                                        </p>
                                      </div>
                                    </Row>
                                  </Col>
                                </Row>
                              </Col>
                              {/* PO statement */}
                              <Col span={24} className="add-create-item-table">
                                <table className="mb-6 table-purchase-serial table-responsive">
                                  <thead>
                                    <tr className="table-activities-head-main">
                                      <th className="w-[5%] uppercase table-activities-purchase-head text-[12px] font-semibold">
                                        S.No
                                      </th>
                                      <th className="w-[20%] uppercase table-activities-purchase-head text-[12px] font-semibold">
                                        Model Name
                                      </th>
                                      <th className="w-[20%] uppercase table-activities-purchase-head text-[12px] font-semibold">
                                        IMEI
                                      </th>
                                      <th className="w-[20%] uppercase table-activities-purchase-head text-[12px] font-semibold">
                                        RAM
                                      </th>
                                      <th className="w-[10%] uppercase table-activities-purchase-head text-[12px] font-semibold">
                                        Qty
                                      </th>
                                      <th className="w-[15%] uppercase table-activities-purchase-head text-[12px] font-semibold">
                                        Rate
                                      </th>
                                      <th className="w-[15%] uppercase table-activities-purchase-head text-[12px] font-semibold">
                                        Discount
                                      </th>
                                      <th className="w-[20%] uppercase text-end table-sales-invoice-print-main-head text-[12px] font-semibold">
                                        Amount
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody className="mb-8">
                                    {itemsDetailsArray &&
                                    itemsDetailsArray &&
                                    itemsDetailsArray.length > 0
                                      ? itemsDetailsArray.map((data, index) => {
                                          const serialDetails =
                                            data && data.serialDetails
                                              ? data.serialDetails
                                              : "";
                                          // const serialDetails =
                                          //   data.serialDetails &&
                                          //   data.serialDetails.length > 0
                                          //     ? data.serialDetails[0]
                                          //     : "";
                                          return (
                                            <tr
                                              key={index}
                                              className={
                                                "table-purchase-row border border-b-1 border-x-0 border-t-0"
                                              }
                                            >
                                              <td
                                                className={
                                                  downloadLoading
                                                    ? "table-activities-purchase-data pt-1 pb-2 pr-1 pl-1"
                                                    : "table-activities-purchase-data p-1"
                                                }
                                              >
                                                {index + 1}
                                              </td>
                                              <td
                                                className={
                                                  downloadLoading
                                                    ? "table-activities-purchase-data pt-1 pb-2 pr-1 pl-1"
                                                    : "table-activities-purchase-data p-1"
                                                }
                                              >
                                                {data.modelName}
                                              </td>
                                              <td
                                                className={
                                                  downloadLoading
                                                    ? "table-activities-purchase-data pt-1 pb-2 pr-1 pl-1"
                                                    : "table-activities-purchase-data p-1"
                                                }
                                              >
                                                {serialDetails
                                                  ? serialDetails.IMEI
                                                  : ""}
                                              </td>
                                              <td
                                                className={
                                                  downloadLoading
                                                    ? "table-activities-purchase-data pt-1 pb-2 pr-1 pl-1"
                                                    : "table-activities-purchase-data p-1"
                                                }
                                              >
                                                {serialDetails
                                                  ? serialDetails.ramName
                                                  : ""}
                                              </td>
                                              <td
                                                className={
                                                  downloadLoading
                                                    ? "table-activities-purchase-data pt-1 pb-2 pr-1 pl-1"
                                                    : "table-activities-purchase-data p-1 text-end"
                                                }
                                              >
                                                {data.qty
                                                  ? data.qty + " PCS"
                                                  : 0 + " PCS"}
                                              </td>

                                              <td
                                                className={
                                                  downloadLoading
                                                    ? "table-activities-purchase-data pt-1 pb-2 pr-1 pl-1"
                                                    : "table-activities-purchase-data p-1 text-end"
                                                }
                                              >
                                                {serialDetails &&
                                                (serialDetails.sellingPrice !=
                                                  null ||
                                                  serialDetails.sellingPrice !=
                                                    undefined)
                                                  ? serialDetails.sellingPrice.toLocaleString(
                                                      "en-IN"
                                                    )
                                                  : ""}
                                              </td>
                                              <td
                                                className={
                                                  downloadLoading
                                                    ? "table-activities-purchase-data pt-1 pb-2 pr-1 pl-1"
                                                    : "table-activities-purchase-data p-1 text-end"
                                                }
                                              >
                                                {serialDetails &&
                                                (serialDetails.discountAmount !=
                                                  null ||
                                                  serialDetails.discountAmount !=
                                                    undefined)
                                                  ? serialDetails.discountAmount.toLocaleString(
                                                      "en-IN"
                                                    )
                                                  : ""}
                                              </td>
                                              <td
                                                className={
                                                  downloadLoading
                                                    ? "table-sales-invoice-print-data pt-1 pb-2 pr-1 pl-1"
                                                    : "table-sales-invoice-print-data p-1 text-end"
                                                }
                                              >
                                                {serialDetails &&
                                                (serialDetails.totalAmount !=
                                                  null ||
                                                  serialDetails.totalAmount !=
                                                    undefined)
                                                  ? serialDetails.totalAmount.toLocaleString(
                                                      "en-IN"
                                                    )
                                                  : ""}
                                              </td>
                                            </tr>
                                          );
                                        })
                                      : ""}
                                    <tr
                                      style={{
                                        borderTop: "1px solid black",
                                        borderBottom: "1px solid black",
                                        borderRight: "none",
                                      }}
                                      className="font-semibold"
                                    >
                                      <td
                                        className="p-[70px] uppercase font-semibold text-[14px]"
                                        colSpan={8}
                                      >
                                        {""}
                                      </td>
                                    </tr>

                                    <tr
                                      style={{
                                        borderTop: "1px solid black",
                                        borderBottom: "1px solid black",
                                        backgroundColor: "#e7e7e7",
                                      }}
                                      className="font-semibold mt-[100px]"
                                    >
                                      <td
                                        className="uppercase table-activities-purchase-head p-2 font-semibold text-[14px]"
                                        // colSpan={2}
                                      >
                                        {""}
                                      </td>
                                      <td
                                        className="text-end table-activities-purchase-head uppercase p-2 font-semibold text-[12px]"
                                        colSpan={1}
                                      >
                                        {"Grand Total"}
                                      </td>
                                      <td className="text-end table-activities-purchase-head uppercase p-2 font-semibold text-[12px]"></td>
                                      <td className="text-end table-activities-purchase-head uppercase p-2 font-semibold text-[12px]"></td>

                                      <td className="table-activities-purchase-total-head p-2 text-end">
                                        <p className="">
                                          {totals.quantityCount}
                                        </p>
                                      </td>
                                      <td className="table-activities-purchase-head p-2">
                                        {""}
                                      </td>
                                      <td
                                        colSpan={2}
                                        className="table-sales-invoice-print-total-head p-2 text-end"
                                      >
                                        <p className="">
                                          {salesInvoiceData &&
                                          salesInvoiceData.netTotalAmount
                                            ? "₹ " +
                                              salesInvoiceData.netTotalAmount
                                            : "₹ " + 0}
                                        </p>
                                      </td>
                                    </tr>
                                    <tr
                                      style={{
                                        borderTop: "1px solid black",
                                        borderBottom: "1px solid black",
                                      }}
                                      className="font-semibold mt-[100px]"
                                    >
                                      <td
                                        className="uppercase table-activities-purchase-head p-2 font-semibold text-[14px]"
                                        colSpan={1}
                                      >
                                        {""}
                                      </td>
                                      <td
                                        className="text-end table-activities-purchase-head uppercase p-2 font-semibold text-[12px]"
                                        colSpan={1}
                                      >
                                        {"Round Off Value"}
                                      </td>
                                      <td className="text-end table-activities-purchase-head uppercase p-2 font-semibold text-[12px]"></td>
                                      <td className="text-end table-activities-purchase-head uppercase p-2 font-semibold text-[12px]"></td>

                                      <td className="table-activities-purchase-total-head p-2 text-end"></td>
                                      <td className="table-activities-purchase-head p-2">
                                        {""}
                                      </td>
                                      <td
                                        colSpan={2}
                                        className="table-sales-invoice-print-total-head p-2 text-end"
                                      >
                                        <div className="flex justify-end">
                                          <p>
                                            {salesInvoiceData.isautoroundoffadd &&
                                            salesInvoiceData.isautoroundoffadd ==
                                              true
                                              ? "(+)"
                                              : salesInvoiceData.isautoroundoffreduce &&
                                                salesInvoiceData.isautoroundoffreduce ==
                                                  true
                                              ? "(-)"
                                              : ""}
                                          </p>

                                          <p className="ml-1">
                                            {salesInvoiceData &&
                                            salesInvoiceData.autoroundoffamount
                                              ? "₹ " +
                                                salesInvoiceData.autoroundoffamount.toLocaleString(
                                                  "en-IN"
                                                )
                                              : "₹ " + 0}
                                          </p>
                                        </div>
                                      </td>
                                    </tr>
                                    <tr className="font-semibold ">
                                      <td
                                        className="uppercase table-activities-purchase-head p-2 font-semibold text-[14px]"
                                        colSpan={1}
                                      >
                                        {""}
                                      </td>
                                      <td
                                        className="uppercase text-end table-activities-purchase-head uppercase p-2 font-semibold text-[12px]"
                                        colSpan={1}
                                      >
                                        {"Received Amount"}
                                      </td>

                                      <td className="table-activities-purchase-total-head p-2 text-end"></td>
                                      <td className="table-activities-purchase-head p-2"></td>
                                      <td className="table-activities-purchase-head p-2"></td>
                                      <td className="table-activities-purchase-head p-2"></td>
                                      <td
                                        colSpan={2}
                                        className="table-sales-invoice-print-total-head p-2 text-end"
                                      >
                                        <p className="">
                                          {salesInvoiceData &&
                                          salesInvoiceData.amountreceived
                                            ? "₹ " +
                                              salesInvoiceData.amountreceived
                                            : "₹ " + 0}
                                        </p>
                                      </td>
                                    </tr>
                                    <tr
                                      style={{
                                        borderBottom: "1px solid black",
                                      }}
                                      className="font-semibold "
                                    >
                                      <td
                                        className="uppercase table-activities-purchase-head p-2 font-semibold text-[14px]"
                                        colSpan={1}
                                      >
                                        {""}
                                      </td>
                                      <td
                                        className="text-end uppercase table-activities-purchase-head uppercase p-2 font-semibold text-[12px]"
                                        colSpan={1}
                                      >
                                        {"Balance Amount"}
                                      </td>

                                      <td className="table-activities-purchase-head p-2 text-end"></td>
                                      <td className="table-activities-purchase-head p-2">
                                        {""}
                                      </td>
                                      <td className="table-activities-purchase-head p-2 text-end"></td>
                                      <td className="table-activities-purchase-head p-2">
                                        {""}
                                      </td>
                                      <td
                                        colSpan={2}
                                        className="table-sales-invoice-print-total-head p-2 text-end"
                                      >
                                        <p className="">
                                          {salesInvoiceData &&
                                          salesInvoiceData.balanceAmount
                                            ? "₹ " +
                                              salesInvoiceData.balanceAmount
                                            : "₹ " + 0}
                                        </p>
                                      </td>
                                    </tr>
                                    <tr
                                      style={{
                                        borderBottom: "1px solid black",
                                      }}
                                      className="font-semibold "
                                    >
                                      <td
                                        className="uppercase table-activities-purchase-head p-2 font-semibold text-[14px]"
                                        // colSpan={2}
                                      >
                                        {""}
                                      </td>
                                      <td
                                        className="text-end uppercase table-activities-purchase-head uppercase p-2 font-semibold text-[12px]"
                                        // colSpan={2}
                                      >
                                        {"Overall Discount"}
                                      </td>

                                      <td className="table-activities-purchase-head p-2 text-end"></td>
                                      <td className="table-activities-purchase-head p-2">
                                        {""}
                                      </td>
                                      <td className="table-activities-purchase-head p-2 text-end"></td>
                                      <td className="table-activities-purchase-head p-2">
                                        {""}
                                      </td>
                                      <td
                                        colSpan={2}
                                        className="table-sales-invoice-print-total-head p-2 text-end"
                                      >
                                        <p className="">
                                          {salesInvoiceData &&
                                          salesInvoiceData.overallDiscount > 0
                                            ? "₹ " +
                                              salesInvoiceData.overallDiscount
                                            : "₹ " + 0}
                                        </p>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                {/* <table className="mt-[100px] w-[100%]">
                                  <tbody className="w-[100%]">
                                
                                  </tbody>
                                </table> */}
                                {/* <table className="w-[100%]">
                                  <tbody className="w-[100%]">
                                  
                                  </tbody>
                                </table> */}

                                {/* <table className="w-[100%]">
                                  <tbody className="w-[100%]">
                                 
                                  </tbody>
                                </table> */}
                                <Row className="">
                                  <Col
                                    md={24}
                                    style={{
                                      width: salesPrint ? "100%" : "",
                                      borderBottom: salesPrint
                                        ? "1px solid black"
                                        : "1px solid black",
                                      padding: "10px",
                                    }}
                                  >
                                    <div className="purchase-label">
                                      <h1 className="font-semibold text-start text-[14px]">
                                        Total Amount (in words)
                                      </h1>
                                      <h1 className="mt-1 font-medium text-[12px] text-start">
                                        {salesInvoiceData &&
                                        salesInvoiceData.netTotalAmount
                                          ? toWords.convert(
                                              salesInvoiceData.netTotalAmount,
                                              {
                                                currency: true,
                                                ignoreDecimal: true,
                                              }
                                            )
                                          : ""}
                                      </h1>
                                    </div>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col md={24} className="p-2 mb-[-4px]">
                                    <div className="purchase-label">
                                      <h1 className="font-semibold text-[14px]">
                                        Notes
                                      </h1>
                                      <p className="text-[12px]">
                                        {salesInvoiceData
                                          ? salesInvoiceData.notes
                                          : ""}
                                      </p>
                                    </div>
                                  </Col>
                                  <Col md={24} className="p-2">
                                    <div className="purchase-label">
                                      <h1 className="font-semibold text-[14px]">
                                        Terms and Conditions
                                      </h1>
                                      <p className="text-[12px]">
                                        {salesInvoiceData
                                          ? salesInvoiceData.termsandconditions
                                          : ""}
                                      </p>
                                    </div>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                    {/* <Col
                      span={3}
                      style={{
                        position: "fixed",
                        top: 214,
                        right: 20,
                      }}
                      className="mb-4 pb-6 ml-[50px]"
                    >
                      <div
                        style={{
                          fontFamily: "Poppins",
                        }}
                        className="cursor-pointer border rounded-sm bg-[#ffffff] border-1 flex p-2"
                      >
                        <BsCashCoin className="pr-2" size={22} />
                        Profit Details
                      </div>
                    </Col> */}
                  </Row>
                  <Row className="border border-b-1 border-t-0 border-x-0 flex justify-center mt-3 mb-3"></Row>
                </Col>
              </Row>
            </Col>

            {/* Parties input section with bulk actions */}
          </Row>
        </Col>
      </Row>

      <Modal
        open={pageRouting}
        onOk={() => {
          setPageRouting(false);
          history.push("/sales-invoice");
        }}
        closeIcon
        maskClosable={false}
        rootClassName="p-15 h-[300px]"
        okText={"Yes, Leave"}
        cancelText={"No, Stay"}
        onCancel={() => setPageRouting(false)}
        footer={(_, { OkBtn, CancelBtn }) => (
          <div className="text-center flex justify-center">
            <div className="mr-3">
              <OkBtn />
            </div>
            <CancelBtn />
          </div>
        )}
        width={500}
      >
        <div className="text-center w-[100%]">
          <ExclamationCircleOutlined className="mb-2 text-center text-[#f1c40f] font-bold text-[44px]" />
          <h1 className="text-center text-[18px] font-bold">
            Are you sure you want to leave this page?
          </h1>
          <p className="text-center text-[14px] mt-2">
            All unsaved changes will be lost!
          </p>
        </div>
      </Modal>

      {/* Delete purchase modal */}

      <Modal
        open={deletePurchaseModal}
        onOk={() => {
          deletePurchaseInvoiceDetails();
        }}
        closeIcon
        maskClosable={false}
        okText={`Delete Sales invoice`}
        cancelText={"Cancel"}
        okType="danger"
        onCancel={() => setDeletePurchaseModal(false)}
        okButtonProps={{
          disabled: isButtonDisabled ? true : false,
        }}
        height={300}
        footer={(_, { OkBtn, CancelBtn }) => (
          <div className="text-center flex justify-center">
            <CancelBtn />
            <div className="ml-3">
              <OkBtn />
            </div>
          </div>
        )}
      >
        <div className="text-center w-[100%] p-4">
          <ExclamationCircleOutlined className="mb-2 text-center text-[#f1c40f] font-bold text-[44px]" />
          <h1 className="text-center text-[18px] font-bold">
            Are you sure you want to delete these sales?
          </h1>
          <p className="text-center text-[14px] mt-2">
            The selected sales will be deleted from the sales Inventory. Once
            deleted you will not be able to restore these sales.
          </p>
        </div>
      </Modal>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        style={{
          fontSize: "12px",
        }}
        pauseOnHover
        theme="colored"
      />
    </React.Fragment>
  );
};

SalesInvoiceSelection.propTypes = {
  location: PropTypes.any,
};

export default SalesInvoiceSelection;
